import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  FaEnvelope,
  FaBriefcase,
  FaMapMarkerAlt,
  FaThLarge,
  FaSearch,
  FaClock,
  FaCheckCircle,
  FaChevronDown,
} from 'react-icons/fa';
import { environmentalURL } from '../environmentalURL';
const CareerSection = () => {
  const [jobs, setJobs] = useState([]);
  const navigate = useNavigate();
  const [titleFilter, setTitleFilter] = useState('');
  const [locationFilter, setLocationFilter] = useState('');
  const [keywordFilter, setKeywordFilter] = useState('');


useEffect(() => {
  axios
    .get(`${environmentalURL}/api/jobs/findall`)
    .then(res => {
      setJobs(res.data);
    })
    .catch(err => console.error('Error fetching job data:', err));
}, []);

  const badgeStyle = {
    backgroundColor: '#f1f3f5',
    borderRadius: '999px',
    padding: '6px 12px',
    fontSize: '13px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#333',
  };

  const reqItem = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '6px',
    color: '#555',
  };

  const checkIcon = {
    color: '#2b7111ff',
    marginRight: '8px',
  };

  const filteredJobs = jobs.filter(job => {
    const titleMatch = titleFilter
      ? job.position.toLowerCase().includes(titleFilter.toLowerCase())
      : true;
    const locationMatch = locationFilter
      ? job.state.toLowerCase().includes(locationFilter.toLowerCase())
      : true;
    const keywordMatch = keywordFilter
      ? job.description.toLowerCase().includes(keywordFilter.toLowerCase()) ||
        job.position.toLowerCase().includes(keywordFilter.toLowerCase())
      : true;
    return titleMatch && locationMatch && keywordMatch;
  });

  return (
    <>
      <section
        style={{
          padding: '50px',
          background: 'linear-gradient(to right, #118945ff, #236a29)',
          textAlign: 'center',
          color: '#fff',
        }}
      >
        <h1 style={{ fontSize: '45px', fontWeight: 'bold', marginBottom: '20px', lineHeight: '1.4' }}>
          <span style={{ color: '#25ff95ff' }}>Build the Future</span> <br />
          <span style={{ color: '#fff' }}> With Us</span>
        </h1>
        <p
          style={{
            fontSize: '18px',
            marginBottom: '30px',
            maxWidth: '800px',
            marginInline: 'auto',
            color: 'white',
          }}
        >
          Join a team of dedicated innovators building transformative products that positively impact lives across the globe.
        </p>

     {/* Search Bar */}
<div
  className="search-bar"
  style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: '15px 20px',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    gap: '15px',
    width: '750px',
    margin: 'auto',
    marginBottom: '30px',
    flexWrap: 'wrap', // ✅ helps wrapping in smaller screens
  }}
>
  {/* Job Title Dropdown */}
  <div className="filter-item" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <FaBriefcase style={{ color: '#6c757d', fontSize: '16px' }} />
    <select
      value={titleFilter}
      onChange={e => setTitleFilter(e.target.value)}
      style={{
        padding: '8px 12px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: 'transparent',
        color: '#333',
        fontSize: '14px',
        outline: 'none',
      }}
    >
      <option value="">Job Title</option>
      <option value="UI/ UX Design">UI/ UX Design</option>
      <option value="Software Testing">Software Testing</option>
      <option value="Project Manager">Project Manager</option>
      <option value="IOS Developer">IOS Developer</option>
      <option value="Java Developer">Java Developer</option>
      <option value="Help Desk">Help Desk</option>
      <option value="Dot Net Developer">Dot Net Developer</option>
      <option value="Database Developer">Database Developer</option>
    </select>
  </div>

  {/* Location Dropdown */}
  <div className="filter-item" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <FaMapMarkerAlt style={{ color: '#6c757d', fontSize: '16px' }} />
    <select
      value={locationFilter}
      onChange={e => setLocationFilter(e.target.value)}
      style={{
        padding: '8px 12px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: 'transparent',
        color: '#333',
        fontSize: '14px',
        outline: 'none',
      }}
    >
      <option value="">Location</option>
      <option value="Hyderabad">Hyderabad</option>
      <option value="Bangalore">Bangalore</option>
      <option value="Mumbai">Mumbai</option>
      <option value="Delhi">Delhi</option>
      <option value="Chennai">Chennai</option>
      <option value="Rajasthan">Rajasthan</option>
    </select>
  </div>

  {/* Keyword Search */}
  <div className="filter-item" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
    <FaThLarge style={{ color: '#6c757d', fontSize: '16px' }} />
    <input
      type="text"
      value={keywordFilter}
      onChange={e => setKeywordFilter(e.target.value)}
      placeholder="Your keyword..."
      style={{
        padding: '8px 12px',
        border: 'none',
        borderRadius: '6px',
        backgroundColor: 'transparent',
        color: '#333',
        fontSize: '14px',
        outline: 'none',
      }}
    />
  </div>

  <button
    className="search-btn"
    style={{
      backgroundColor: '#47d53dff',
      color: '#fff',
      padding: '10px 18px',
      borderRadius: '8px',
      border: 'none',
      cursor: 'pointer',
      fontWeight: 500,
      display: 'flex',
      alignItems: 'center',
      marginLeft:"0px"
    }}
  >
    <FaSearch style={{ marginRight: '6px' }} />
    Search
  </button>
</div>

<style>
{`
  /* ✅ Mobile Responsiveness */
  @media (max-width: 768px) {
    .search-bar {
      flex-direction: column;
      width: 100% !important;   /* take full width on mobile */
      gap: 12px;
    }

    .filter-item, .search-btn {
      width: 100%;   /* each element full width */
      justify-content: flex-start;
    }

    .search-btn {
      justify-content: center;  /* center the button */
    }
  }
`}
</style>

      </section>

      <section style={{ padding: '60px 5%', backgroundColor: '#fff', color: '#1b1f3b' }}>
        <h2 style={{ textAlign: 'center', fontSize: '32px', fontWeight: 'bold', marginBottom: '10px' }}>
          Open Positions
        </h2>
        <p style={{ textAlign: 'center', marginBottom: '40px', fontSize: '16px', color: '#555' }}>
          Find your next opportunity and join our growing team
        </p>

        {/* Job Cards */}
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '30px',
            justifyContent: 'space-between',
          }}
        >
          {filteredJobs.map((job, index) => (
            <div
              key={index}
              style={{
                background: '#fff',
                padding: '25px',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                marginBottom: '30px',
                position: 'relative',
                flex: '1 1 48%',
                minWidth: '300px',
              }}
            >
              <h3 style={{ marginBottom: '15px' }}>{job.position}</h3>

              <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
                <span style={badgeStyle}><FaBriefcase /> {job.educationLevel}</span>
                <span style={badgeStyle}><FaMapMarkerAlt /> {job.state}</span>
                <span style={badgeStyle}><FaClock /> {job.jobType}</span>
              </div>

              <strong>Requirements:</strong>
              <ul style={{ listStyle: 'none', paddingLeft: 0, marginTop: '8px' }}>
                {job.description &&
                  job.description.split('.').map((sentence, idx) => {
                    const trimmed = sentence.trim();
                    return (
                      trimmed && (
                        <li key={idx} style={reqItem}>
                          <FaCheckCircle style={checkIcon} /> {trimmed}.
                        </li>
                      )
                    );
                  })}
              </ul>

              <button
                onClick={() =>
                  navigate('/job-application', {
                    state: {
                      title: job.position,
                      qualification: job.educationLevel,
                      location: job.state,
                      type: job.jobType,
                      requirements: job.description
                        ?.split('.')
                        .map(r => r.trim())
                        .filter(Boolean),
                    },
                  })
                }
                style={{
                  marginTop: '20px',
                  background: 'linear-gradient(90deg, #2e7d2dff, #15b100ff)',
                  color: '#fff',
                  padding: '10px 20px',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontWeight: 'bold',
                }}
              >
                Apply Now →
              </button>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div
          style={{
            background: 'linear-gradient(to right, #6e8dd0ff, #03b37bff)',
            borderRadius: '20px',
            padding: '50px 20px',
            textAlign: 'center',
            margin: '40px auto',
            maxWidth: '1200px',
          }}
        >
          <h2 style={{ color: '#fff', fontWeight: 'bold', fontSize: '2rem' }}>
            New Things Will Always <br />
            Update Regularly
          </h2>

          <div
            style={{
              marginTop: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              maxWidth: '600px',
              marginInline: 'auto',
              backgroundColor: '#fff',
              borderRadius: '10px',
              overflow: 'hidden',
            }}
          >
            <div style={{ padding: '0 15px', display: 'flex', alignItems: 'center', color: '#888' }}>
              <FaEnvelope />
            </div>
            <input
              type="email"
              placeholder="Enter Your Email"
              style={{
                flex: '1',
                border: 'none',
                outline: 'none',
                padding: '15px',
                fontSize: '16px',
              }}
            />
            <button
              style={{
                backgroundColor: 'rgb(88 197 118)',
                color: '#fff',
                border: 'none',
                padding: '15px 20px',
                cursor: 'pointer',
                fontWeight: 'bold',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FaCheckCircle style={{ marginRight: '8px' }} />
              Subscribe
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default CareerSection;
